export enum AvatarType {
    Icon = 'icon',
    Image = 'image',
    Initials = 'initials',
    Number = 'number',
}
